import { toCents, toDollars, toDollarsPretty } from './currency';

import Users from '../api/Users';

//#region ExternalData

const createDownloadCSV=(data)=>{
    const cvsString = data?.map((row)=>row?.join(',')?.join('\n'));

    const blob = new Blob([cvsString], {type: 'text/csv;charset=utf-8;'});

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'data.csv';

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link)
}

export const imageToBlob = (src, fileName) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
    
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
    
        canvas.toBlob((blob) => {
            if (blob) {
            const file = new File([blob], fileName, { type: blob.type, size: blob.size });
            resolve(file);
            } else {
            reject('Failed to convert image to Blob.');
            }
        });
        };
        img.onerror = (err) => reject(err);
        
        img.src = src;
    });
}

//#endregion ExternalData

//#region User Utilities

/** This is to get phone numbers on for receipts, primarily for online orders.  Used on multiple receipts. 
 * 
 * Order should have a memo or a user that has .mobile_phone or .home_phone
*/
export const figureOutPhone=(order)=>{
    let phone;
    if(order?.memo && order?.memo?.includes("phone_number:")) {
        phone = order.memo.split(":")[1]
    } //user put this one in at checkout, use it - they may be using a temp number, who knows 
    else if(order?.user?.mobile_phone) phone = order?.user?.mobile_phone;
    else if(order?.user?.home_phone) phone = order?.user?.home_phone;
    else phone = ""
    return phone;
}

//#endregion User Utilities

//#region Other
export const handleUriDownload = (uri) =>{
    let download = document.createElement('a');
    download.href = uri;
    download.setAttribute('download', '');
    document.body.appendChild(download);
    download.click();
    download.parentNode.removeChild(download);
}

//#endregion Other

//#region Payments/Monies
/**
 * This function does the converting to cents and to dollars for more accurate math.  Used in places like Roster Tabs and Unpaid Events
 * 
 */
export const handleMemberCharges=(charges, members)=>{
    //have to handle the different data formats
    if(members?.length > 0) members = members.map((member)=>{
        if(!member.id && member.hasOwnProperty("user_id")) member.id = member.user_id;
        return member;
    })
    let totalCharges = {
        totalOwed: 0,
        totalPaid: 0,
        totalBalance: 0,
        members:[]
    };
    members?.forEach((member)=>{
        const memberCharges=charges[member.id]
        let totalOwed = 0;
        let totalPaid = 0;
        member.charges = []
        if(memberCharges && memberCharges.length > 0){
            memberCharges.forEach((charge)=>{
                totalCharges.totalOwed += toCents(charge.payment_totals?.final_price);
                totalCharges.totalPaid += toCents(charge.payment_totals?.total_paid);
                totalOwed += toCents(charge.payment_totals?.final_price) ||  0;
                totalPaid += toCents(charge.payment_totals?.total_paid) || 0;
                
                charge.owed = charge.payment_totals?.final_price || 0;
                charge.paid = charge.payment_totals?.total_paid || 0;
                //convert them to "pretty" text
                charge.balance = toDollars(toCents(charge.owed) - toCents(charge.paid));
                charge.for_user_id = member.id;
                
                member.charges.push(charge)
            })
        }
        member.totalBalance = toDollars(totalOwed - totalPaid);
        member.totalOwed = toDollarsPretty(totalOwed);
        member.totalPaid = toDollarsPretty(totalPaid);
        totalCharges.members.push(member)
    })
    //convert them to "pretty" format
    totalCharges.totalBalance = toDollarsPretty(totalCharges.totalOwed - totalCharges.totalPaid) || 0;
    totalCharges.totalOwed = toDollarsPretty(totalCharges.totalOwed)
    totalCharges.totalPaid = toDollarsPretty(totalCharges.totalPaid)

    return totalCharges;
}


/** Family should be filtered before this only include family in which the user has auth over */
export const getLatestOutstanding=async(id, user, familyIds, family=[])=>{
    
    //different data from different sources is sometimes using one or the other, gotta handle for it
    if(!user.id && user.hasOwnProperty("user_id")) user.id = user.user_id;
    if(family?.length > 0) family = family.map((member)=>{
        if(!member.id && member.hasOwnProperty("user_id")) member.id = member.user_id;
        return member;
    })

    if(!familyIds &&family?.length > 0) familyIds = family.map((member)=>member.id);

    const users = [id];
    if(familyIds?.length > 0) users.push(...familyIds);
    const response=await Users.getOutstandingCharges({ user_ids: users, include_payment_totals: true });
    let charges = [], familyCharges = [];
    if (response.data) {
        let chargesData = handleMemberCharges(response.data.outstanding_charges, [user, ...family] )
            
        let authUser = chargesData?.members?.find(member=>member.id === id);
        let familyData = chargesData?.members?.filter(member=>member.id !== id);
        if (charges?.length === 0) charges.push({ name: user.first_name, id: user.id, charges: [] });
        if(authUser?.charges?.length > 0)authUser.charges.forEach((charge) => {
            charges[0].charges.push(charge);
        });

        if(familyData?.length > 0){
            familyData?.forEach((user, i) => {
                if (user.charges?.length) {
                    familyCharges[i] = {
                        name: user.first_name,
                        id: user.id,
                        charges: [],
                    };
                    user.charges?.forEach((charge) => {
                    familyCharges[i]?.charges.push(charge);
                    });
                }
            });
            familyCharges?.forEach((charge) => charges.push(charge))
        }
    }
    return charges;
}

/**
 * A function for the variations of checkins, handling the keydown on the scanner
 */
export const handleWedgeScannerKeyDown = (event) => {
    if (event.key === 'Enter') {
        const scannedText = event.target.value.trim();
        if (scannedText) {
            return scannedText;
        }
    }
}

export const determineIsMobile=(desiredWidth=800)=>{
    let isMobile = window.innerWidth < desiredWidth    
    return isMobile;
}

//#endregion Other